import _ from 'lodash';
import React from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import cssStyle from './Shared.scss';
import { ErrMsg } from './index';

const FormItemGroup = ({
  label,
  labels = [],
  className,
  children,
  separate,
  full,
  labelFontColor,
  style,
  errors,
  paths,
  require = false,
  detail,
}) => {
  const labelSeparation = label ? [{ label, size: 12 }] : labels;

  const errorMessages = () => {
    const errorMessages = _.reduce(
      paths,
      (a, r) => {
        return [...a, errors[r] || undefined];
      },
      []
    ).filter(Boolean);
    if (errorMessages.length === 0) return <></>;
    return (
      <Row>
        <Col>
          {errorMessages.map((r, i) => (
            <React.Fragment key={i}>
              <ErrMsg iconStyle={{ marginLeft: '0.5rem', marginRight: '0.25rem' }} message={r} />
            </React.Fragment>
          ))}
        </Col>
      </Row>
    );
  };
  const Label = (v) => {
    return (v || '').split('\n').map((r, i) => {
      return (
        <React.Fragment key={i}>
          {r}
          {require && <span style={{ color: 'red' }}>*</span>}
          <br />
        </React.Fragment>
      );
    });
  };
  return (
    <Form.Group style={style} className={className}>
      <Row>
        {labelSeparation.map((l, i) => {
          return (
            <React.Fragment key={i}>
              <Col xs={l.size}>
                <Form.Label className={cssStyle.formLabel} style={{ color: labelFontColor }}>
                  {Label(l.label)}
                </Form.Label>
              </Col>
            </React.Fragment>
          );
        })}
      </Row>
      {full ? (
        <Row>
          <Col>{children}</Col>
        </Row>
      ) : (
        <Row>{children}</Row>
      )}
      {errorMessages()}
      {<span style={{ color: 'gray' }}>{detail}</span>}
      {separate ? <div className={cssStyle.bottomBorder} /> : <></>}
    </Form.Group>
  );
};

FormItemGroup.propTypes = {
  label: PropTypes.string,
  children: PropTypes.node.isRequired,
  labelFontColor: PropTypes.string,
  full: PropTypes.bool,
  last: PropTypes.bool,
  separate: PropTypes.bool,
  style: PropTypes.object,
  className: PropTypes.string,
  paths: PropTypes.array,
  errors: PropTypes.object,
  require: PropTypes.bool,
  detail: PropTypes.string,
};

FormItemGroup.defaultProps = {
  separate: false,
  full: true,
  labelFontColor: '#7a7a7a',
  paths: [],
  errors: {},
};
export default FormItemGroup;
